import common from '../../../common';

const _draw = Symbol('_draw');

export default class ColourBrush{
	constructor() {
		// Constants.
		this.LINE_THICKNESS = 10;
		// Attributes.
		this._drawLayer = null;
		this._colour = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;
	}

	onDrawBegan(point){
		this[_draw](point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
	}

	onDrawMoved(from, to){
		this[_draw](from, to);
	}

	onDrawEnded(){}

	[_draw](start, end){
		const distanceBetween = (point1, point2)=>{
			return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
		};

		const angleBetween = (point1, point2)=>{
			return Math.atan2(point2.x - point1.x, point2.y - point1.y);
		};

		const dist = Math.round(distanceBetween(start, end));
		const angle = angleBetween(start, end);

		let lastX = Math.round(start.x + ( Math.sin(angle) * dist)), lastY = Math.round(start.y + ( Math.cos(angle) * dist ));

		for (let i = 0; i < dist; i += 3) {
			let x = Math.round(start.x + ( Math.sin(angle) * i ));
			let y = Math.round(start.y + ( Math.cos(angle) * i ));

			const radGrad = this._drawLayer.context.createRadialGradient(lastX, lastY, this.LINE_THICKNESS, x, y, 0);
			const rgbColour = common.hexToRgb(this._colour);
			radGrad.addColorStop(0, 'rgba( ' + rgbColour.r + ',' + rgbColour.g + ',' + rgbColour.b + ', 0 )');
			radGrad.addColorStop(1, 'rgba( ' + rgbColour.r + ',' + rgbColour.g + ',' + rgbColour.b + ', 1 )');

			this._drawLayer.context.fillStyle = radGrad;
			this._drawLayer.context.fillRect(x - this.LINE_THICKNESS, y - this.LINE_THICKNESS, this.LINE_THICKNESS * 2, this.LINE_THICKNESS * 2);

			lastX = x;
			lastY = y;
		}

		this._drawLayer.onContext_Changed();
	}

	get colour() {
		return this._colour;
	}

	set colour(value) {
		this._colour = value;
	}
}